// lib/routes.ts

export const routes = {
  // Main navigation
  root: '/',
  penetration_testing_path: '/penetration-testing',
  penetration_testing_faqs_path: '/penetration-testing/faqs',
  penetration_testing_guide_path: '/penetration-testing-guide',
  social_engineering_path: '/social-engineering',
  red_teaming_path: '/red-teaming',
  vulnerability_scans_path: '/vulnerability-scans',
  managed_siem_path: '/managed-siem',
  iso_27001_path: '/iso-27001',
  iso_27701_path: '/iso-27701',
  iso_9001_path: '/iso-9001',
  gdpr_path: '/gdpr',
  outsourced_dpo_path: '/outsourced-dpo',
  cyber_essentials_path: '/cyber-essentials',
  cyber_essentials_faqs_path: '/cyber-essentials/faqs',
  incident_response_path: '/incident-response',
  digital_forensics_path: '/digital-forensics',
  gdpr_training_path: '/gdpr-training',
  security_training_path: '/security-training',
  compliance_services_path: '/compliance-services',
  training_services_path: '/training-services',
  virtual_ciso_path: '/virtual-ciso',
  detection_response_services_path: '/detection-response-services',
  cyber_security_assessment_path: '/cyber-security-assessment',
  pci_dss_path: '/pci-dss',

  // Sub navigation
  about_path: '/about',
  contact_path: '/contact',
  soc_path: '/soc',
  resources_path: '/resources',
  blog_path: '/blog',
  blog_post_path: (slug: string) => `/blog/${slug}`,
  blog_author_path: (author: string) => `/blog/author/${author}`,
  case_studies_path: '/case-studies',
  industry_reports_path: '/industry-reports',
  industry_report_path: (slug: string) => `/industry-reports/${slug}`,
  white_papers_path: '/white-papers',
  white_paper_path: (slug: string) => `/white-papers/${slug}`,
  infographics_path: '/infographics',
  partners_path: '/partners',
  partner_path: (slug: string) => `/partners/${slug}`,
  events_path: '/events',
  event_path: (slug: string) => `/events/${slug}`,
  webinars_path: '/webinars',
  webinar_path: (slug: string) => `/webinars/${slug}`,

  // Sub pages
  colocation_path: '/colocation',
  cyber_security_accreditations_path: '/cyber-security-accreditations',
  dpo_for_schools_path: '/dpo-for-schools',
  pen_testing_lp_path: '/lp/penetration-testing',
  mdr_path: '/mdr',
  data_protection_services_path: '/data-protection-services',
  dora_path: '/dora',
  partner_resources_path: '/partner-resources',
  pen_testing_packages_path: '/pen-testing-packages',

  // Penetration testing routes
  penetration_testing_enterprise_path: '/penetration-testing/enterprise-penetration-testing',
  penetration_testing_cloud_path: '/penetration-testing/cloud-penetration-testing',
  penetration_testing_mobile_path: '/penetration-testing/mobile-penetration-testing',
  penetration_testing_network_path: '/penetration-testing/network-penetration-testing',
  penetration_testing_int_ext_network_path: '/penetration-testing/internal-external-network-penetration-testing',
  penetration_testing_web_application_path: '/penetration-testing/web-application-penetration-testing',
  penetration_testing_wireless_path: '/penetration-testing/wireless-penetration-testing',
  penetration_testing_crest_ovs_path: '/penetration-testing/crest-ovs',
  penetration_testing_api_path: '/penetration-testing/api-penetration-testing',

  // ISO routes
  iso_27002_gap_analysis_path: '/iso-27001/gap-analysis/iso-27002-gap-analysis',
  iso_27001_gap_analysis_path: '/iso-27001/gap-analysis',
  iso_27001_2022_path: '/iso-27001/iso-27001-2022',
  iso_27001_audit_path: '/iso-27001/audit',
  iso_27001_implementation_path: '/iso-27001/implementation',
  iso_27001_maintenance_path: '/iso-27001/maintenance',

  // GDPR routes
  gdpr_audit_path: '/gdpr/audit',
  gdpr_implementation_path: '/gdpr/implementation',
  gdpr_gap_analysis_path: '/gdpr/gap-analysis',

  // Glossary
  jargon_buster_path: '/jargon-buster',

  // Purchases
  purchases_path: '/purchases',
  purchases_thanks_path: '/purchases/thanks',
  purchases_sorry_path: '/purchases/sorry',

  // Miscellaneous
  nhs_dsp_toolkit_path: '/nhs-dsp-toolkit',
  uk_gdpr_representation_path: '/gdpr/uk-gdpr-representation',
  soc2_path: '/soc2',
  security_checklist_path: '/10-point-security-checklist',
  security_checklist_thank_you_path: '/10-point-security-checklist/thank-you',
  bulletproof_acquired_path: '/press-release/bulletproof-acquired-by-grc-group',

  // Legal pages
  privacy_notice_path: '/privacy-notice',
  appropriate_policy_document_path: '/appropriate-policy-document',
  cookie_policy_path: '/cookie-policy',
  terms_path: '/terms',
  partner_terms_path: '/partner-terms',
  thanks_path: '/thanks',
  survey_terms_conditions_path: '/survey-terms-conditions',
  vulnerability_disclosure_policy_path: '/vulnerability-disclosure-policy',

  // Landing pages
  penetration_testing_service_path: '/penetration-testing-service',
  outsourced_dpo_services_path: '/outsourced-dpo-services',
} as const;

// Type for routes with parameters
export type DynamicRoute = (param: string) => string;

// Type for all routes
export type Routes = typeof routes;

// Helper type to get all route keys
export type RouteKeys = keyof Routes;

// Helper function to get route
export const getRoute = (key: RouteKeys, param?: string): string => {
  const route = routes[key];
  if (typeof route === 'function' && param) {
    return route(param);
  }
  return route as string;
};